module.exports = __webpack_public_path__ + "static/media/works.8c3f1824.mp4";